var env = {
    // Api
    API2_URL: "https://api2.savlog.net/api/service",
    API_URL: "https://www.districloud.net/app/service/rest/ws.php?action=api_client",
    // Old url: DEMO_API_URL: "https://preprod.savlog.net/preproduction/app/service/rest/ws.php?action=api_client",
    DEMO_API_URL: "https://preprod.savlog.net/districloud/app/service/rest/ws.php?action=api_client",
    API_ID: "777",
    API_TOKEN: "MlNykMcT78moIEkwtti4qWP0rwYNNCG",
    PRIVATE_API_TOKEN_KEY: "09cab42c74bd353979d87594db9ac7148771da62",

    // File upload
    API_FILE_URL: "https://www.districloud.net/app/documents/upload/index.php",
    API_DEMO_FILE_URL: "https://preprod.savlog.net/districloud/app/documents/upload/index.php",
    API_FILE_ID: "777",
    API_FILE_TOKEN: "MlNykMcT78moIEkwtti4qWP0rwYNNCG",
    
    DEFAULT_ROUTE: "/"
}

export default env



//////////////////
// WEBPACK FOOTER
// ./.env.js
// module id = NhVR
// module chunks = 1